import React from 'react';
import AiAssistantChat, { AiAssistantMeta } from './AiAssistantChat';
import { ChatMessage } from '../../services/aiAssistantService';
import { AiAssistantAccessInfo } from '../../services/aiAssistantAccessService';

interface AiAssistantSectionProps {
  accessInfo?: AiAssistantAccessInfo;
  accessLoading?: boolean;
  onAccessInfoChange?: (info: AiAssistantAccessInfo) => void;
  sharedMessages?: ChatMessage[];
  onSharedMessagesChange?: (messages: ChatMessage[]) => void;
  sharedMeta?: AiAssistantMeta;
  onSharedMetaChange?: (meta: AiAssistantMeta) => void;
  canToggleDevPreview?: boolean;
}

const AiAssistantSection: React.FC<AiAssistantSectionProps> = ({
  accessInfo,
  accessLoading = false,
  onAccessInfoChange,
  sharedMessages,
  onSharedMessagesChange,
  sharedMeta,
  onSharedMetaChange,
  canToggleDevPreview = false,
}) => (
  <AiAssistantChat
    mode="page"
    accessInfo={accessInfo}
    onAccessInfoChange={onAccessInfoChange}
    accessLoading={accessLoading}
    sharedMessages={sharedMessages}
    onSharedMessagesChange={onSharedMessagesChange}
    sharedMeta={sharedMeta}
    onSharedMetaChange={onSharedMetaChange}
    canToggleDevPreview={canToggleDevPreview}
  />
);

export default AiAssistantSection;
